export const useDocumentHighlight = (documentId: string, revisionId: string) =>
  defineStore(
    `/documents/${documentId}/revisions/${revisionId}/highlight`,
    () => {
      const tokenPositionsToHighlight = ref<number[][]>([]);
      const tokenPositionsToSelectHighlight = ref<number[]>([]);

      const clearAll = () => {
        tokenPositionsToHighlight.value = [];
        clearSelectedHighlight();
      };

      const addPositions = (positions: number[]) => {
        tokenPositionsToHighlight.value = [
          positions,
          ...tokenPositionsToHighlight.value,
        ];
      };

      const removePositions = (positions: number[]) => {
        tokenPositionsToHighlight.value =
          tokenPositionsToHighlight.value.filter((position) => {
            return JSON.stringify(positions) != JSON.stringify(position);
          });
      };

      const clearSelectedHighlight = () => {
        tokenPositionsToSelectHighlight.value = [];
      };

      const setTokenPositionsToHighlight = (positions: number[]) => {
        tokenPositionsToSelectHighlight.value = positions;
      };

      // Sort the token positions then check if the specific position is between them.
      const isTokenHighlighted = computed(() => {
        return (tokenGlobalPosition: number) => {
          return tokenPositionsToHighlight.value.some((positions) => {
            positions.sort((a, b) => a - b);
            var start = positions[0];
            var end = positions[positions.length - 1];

            return tokenGlobalPosition >= start && tokenGlobalPosition <= end;
          });
        };
      });

      // Check if the token position is between the start and end position
      const isTokenSelectHighligted = computed(() => {
        return (tokenGlobalPosition: number) => {
          tokenPositionsToSelectHighlight.value.sort((a, b) => a - b);

          var start = tokenPositionsToSelectHighlight.value[0];
          var end =
            tokenPositionsToSelectHighlight.value[
              tokenPositionsToSelectHighlight.value.length - 1
            ];

          return tokenGlobalPosition >= start && tokenGlobalPosition <= end;
        };
      });

      watch(tokenPositionsToHighlight, () => {
        const positions = [] as number[];

        /// I need to loop through token positions to highlight and for each range of numbers, add positions that include the start and end of the range and everything in between:

        for (var positionRange of tokenPositionsToHighlight.value) {
          var start = positionRange[0];
          var end = positionRange[positionRange.length - 1];

          // loop through from the start to end and add each number to the positions array
          for (var i = start; i <= end; i++) {
            positions.push(i);
          }
        }

        useApplyClassToTokens(positions, "token-is-highlighted");
      });

      watch(tokenPositionsToSelectHighlight, () => {
        /// I need to loop through token positions to highlight and for each range of numbers, add positions that include the start and end of the range and everything in between:

        const positions = [] as number[];

        let index = tokenPositionsToSelectHighlight.value[0];

        while (
          index <=
          tokenPositionsToSelectHighlight.value[
            tokenPositionsToSelectHighlight.value.length - 1
          ]
        ) {
          positions.push(index);
          index++;
        }

        useApplyClassToTokens(positions, "token-is-highlight-selected");

        if (tokenPositionsToSelectHighlight.value.length === 0) return;

        // Grab the token with the first position:
        const tokenPosition = tokenPositionsToSelectHighlight.value[0];

        var span = document.querySelector(
          `span[data-token-position="${tokenPosition}"]`
        );

        if (!span) return;

        span.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      });

      return {
        tokenPositionsToHighlight,
        isTokenHighlighted,
        isTokenSelectHighligted,
        clearAll,
        addPositions,
        removePositions,
        clearSelectedHighlight,
        setTokenPositionsToHighlight,
      };
    }
  );
